import {Lookup} from './Lookup';
import {EmployeeMini} from './EmployeeMini';
import {WfApproveRequest} from "./request/WfApproveRequest";
import {WfCompleteRequest} from "./request/WfCompleteRequest";

export class Requests {
    id: number;
    subject: string;
    description: string;
    requestsTypeId: number;
    requestsClassId: number;
    status: number;
    attribute1: string;
    attribute2: string;
    attribute3: string;
    attribute4: string;
    attribute5: string;
    employee: EmployeeMini;
    employee1: EmployeeMini;
    reqClass: Lookup;
    reqType: Lookup;
    pageStatus: string;
    startDate: string;
    endDate: string;
    active: number;
    rejectDescription:string;
}

export class RequestsRejectRequest extends WfApproveRequest {
    rejectReasonId?: number;
    rejectDescription?: string;
}
export class RequestsCancelRequest extends WfCompleteRequest {
    cancelReasonId?: number;
    cancelDescription?: string;
}
